import { render } from "./PaginationDataTableComponent.vue?vue&type=template&id=89b80fc0&scoped=true"
import script from "./PaginationDataTableComponent.vue?vue&type=script&lang=js"
export * from "./PaginationDataTableComponent.vue?vue&type=script&lang=js"

import "./PaginationDataTableComponent.vue?vue&type=style&index=0&id=89b80fc0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89b80fc0"]])

export default __exports__